
const style = {
    container: {
        primary: {
            backgroundColor: '#000',
            paddingLeft: '0px',
            paddingRight: '0px',
            paddingTop: '6vh',
            paddingBottom: '0vh',
            marginLeft: '0',
            marginRight: '0',
            width: '100%',
            height: '100vmin',
            maxWidth: '100%',
        }
    }
};

export default style;
